var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.1 18.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#929292;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.44.54h1.33V1.87c.29,0,.57,0,.85,0a2,2,0,0,1,1.53.8,2.28,2.28,0,0,1,.41,1V15.8l0,.07a2,2,0,0,1-2,1.69H2.59a2,2,0,0,1-2-2V3.93A2.16,2.16,0,0,1,.6,3.42a2,2,0,0,1,2-1.55h.73V.54H4.66V1.86h8.78ZM16.23,6.8H1.87v8.63c0,.55.25.8.79.8H15.44a.69.69,0,0,0,.79-.79V6.8ZM1.87,5.45H16.23c0-.55,0-1.09,0-1.62a.6.6,0,0,0-.55-.61c-.3,0-.59,0-.91,0V4.52H13.43V3.21H4.66V4.52H3.33V3.2c-.29,0-.56,0-.83,0a.64.64,0,0,0-.62.62C1.87,4.36,1.87,4.9,1.87,5.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.08,9.5V8.19h1.3V9.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,9.51H5.74V8.19H7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.71,8.19V9.5H8.4V8.19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.37,8.2V9.5H11.05V8.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,9.51H13.71V8.2H15Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.08,12.16V10.85h1.3v1.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.05,10.85v1.31H5.74V10.85Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.39,12.16V10.85H9.7v1.31Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.05,10.85h1.31v1.31H11.05Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.71,12.16V10.85H15v1.31Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.08,13.51H4.39v1.31H3.08Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.73,14.82V13.51H7v1.31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.4,13.51H9.7v1.31H8.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.06,13.51h1.3v1.31h-1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1fec25a7421138755dde29a64c9ac964.svg";
export { ForwardRef as ReactComponent };